import * as Yup from 'yup';

export default () =>
    Yup.object().shape({
        discountPercentage: Yup.number().max(100).min(0),
    });
